import React from 'react';
import FooterBreadCrumb from '../../components/common-footer/FooterBreadCrumb';

const TermsCondition = () => {
    // Desktop View
    return (
        <div className="privacy-policy announcement-list-page">
            <div className="privacy-policy-page">

                {/* Main Content */}
                <main className="main-content">

                    {/* Breadcrumb */}
                    <FooterBreadCrumb heading="이용약관" />

                    <div className="content-container">

                        <div className="outer-box">
                            <div className="privacy-text">
                                <p>
                                    아래의 이용약관은 강화파라다이스를 이용하시는 고객님의 권익 보호와 공정한 거래를 위해 제정되었습니다. 고객님의 입장에 서서 최대한 안전하고 편리한 쇼핑 서비스를 제공하기 위해 노력하겠습니다.
                                </p>
                                <p>약관 (공정거래위원회 표준약관 제10023호)</p>

                                <h2>제1장 총 칙 </h2><br />
                                <h3>제1조(목적) </h3>
                                <p>
                                    이 약관은 (이하 "회사"라 한다)의 회원약관에 동의한 모든 회원 및 비회원들을 대상으로 하며, "회사"가 운영하는 웹사이트에서 제공하는 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 웹사이트 과 이용자의 권리의무 및 책임사항을 규정함을 목적으로 합니다.
                                </p>
                                <h3>제2조(정의) </h3>
                                <p>1.웹사이트 : "회사"가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장 혹은 웹사이트을 운영하는
                                    사업자<br />
                                    2.이용자 : "웹사이트"에 접속하여 이 약관에 따라 "웹사이트"가 제공하는 서비스를 받는 회원 및 비회원<br />
                                    3.회원 : "웹사이트"의 회원약관에 동의하여 "회사"에 개인정보를 제공하여 이용계약을 체결한 모든 회원을 지칭하며, "웹사이트"의 정보를 지속적으로 제공받으며, "웹사이트"가 제공하는
                                    서비스를 계속적으로 이용할 수 있는 자<br />
                                    4.비회원 : 회원에 가입하지 않고 "웹사이트"가 제공하는 서비스를 이용하는 자<br />
                                    5.아이디(ID) : 회원의 식별과 서비스 이용을 위하여 회원이 정하고 "회사"가 승인하는 문자 또는 숫자의 조합<br />
                                    6.비밀번호 : 회원이 부여받은 아이디(ID)와 일치되는 회원임을 확인하고 회원의 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합<br />
                                    7.해지 : "회사" 또는 회원이 서비스 개통 후 이용계약을 해약하는 것</p>

                                <h3>제3조 (약관의 명시와 개정) </h3>
                                <p>1. "회사"는 이 약관의 내용과 상호, 영업소 소재지, 대표자의 성명, 사업자등록번호, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 "웹사이트"의 초기 서비스화면(전면)에
                                    게시합니다.<br />
                                    2.이 약관은 "회사"가 제공하는 화면에 게시하거나 기타의 방법으로 이용고객 또는 회원에게 공지하고 회원이 이에 동의함으로써 효력을 발생합니다.<br />
                                    3."회사"는 전자거래기본법, 전자서명법, 정보통신망이용촉진및정보보호등에관한법률, 방문판매등에 관한 법률, 소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수
                                    있습니다.<br />
                                    4."회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 웹사이트의 초기화면에 공지함으로써 그 공지 후 7일이 경과한 날로부터 효력을 발생합니다.<br />
                                    5. 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정전의 약관조항이 그대로 적용됨을 원칙으로 합니다.
                                    다만, 개정약관의 적용를 원하는 회원의 동의절차의 편의를 위하여 이미 계약을 체결한 이용자가 동조 제 4항의 공지에도 불구하고 개정약관 조항의 적용을 받지 않기를 원한다는 이의를
                                    표시하지 않은 경우에는 동조 2항의 동의한 것으로 간주되며 개정약관이 적용됩니다.<br />
                                    6.이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 정부가 제정한 전자거래소비자보호지침 및 관계법령 또는 상관례에 따릅니다.</p>

                                <h3>제4조(서비스의 제공 및 변경) </h3>
                                <p>1."웹사이트"은 다음과 같은 업무를 수행합니다.<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;가) 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;나) 구매계약이 체결된 재화 또는 용역의 배송<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;다) 기타 "웹사이트"가 정하는 업무 <br />
                                    2."웹사이트"은 재화의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화용역의 내용 및
                                    제공일자를 명시하여 현재의 재화용역의 내용을 게시한 곳에 그 제공일자 이전 7일부터 공지합니다.<br />
                                    3."웹사이트"가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 "웹사이트"은 이로 인하여 이용자가 입은 손해를
                                    배상합니다. 단, "웹사이트"에 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.</p>

                                <h3>제5조(서비스의 중단) </h3>
                                <p>1."웹사이트"은 컴퓨터 등 정보통신설비의 보수점검교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.<br />
                                    2.서비스 중단의 경우에는 "웹사이트"은 "웹사이트"가 정한 방법으로 이용자에게 통지합니다.<br />
                                    3."웹사이트"은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단 "웹사이트"에 고의 또는 과실이 없는 경우에는
                                    그러하지 아니합니다.</p><br />

                                <h2>제2장 회원의 가입 및 탈퇴 </h2><br />
                                <h3>제6조(회원가입, 탈퇴, 자격상실등) </h3>
                                <p>1.이용자의 회원 가입, 탈퇴등은 "웹사이트"의 회원가입약관을 준용합니다.<br />
                                    2.단, 전자상거래등을 이용하여 당사와의 거래가 발생된 고객의 경우에는 관련 법률에 의거하여 관련법률에 규정된 기본적인 정보사항만을 계약 해지일로부터 3년 동안 관리 합니다.</p>
                                <br />
                                <h2>제3장 서비스의 이용    </h2><br />
                                <h3>제7조(구매신청)</h3>
                                <p>"웹사이트"가용자는 "웹사이트"상에서 이하의 방법에 의하여 구매신청의 청약을 합니다.<br />
                                    1. 성명, 주소, 전화번호, 주민등록번호 입력<br />
                                    2. 재화 또는 용역의 선택<br />
                                    3. 결제방법의 선택<br />
                                    4. 이 약관에 동의한다는 표시 (예:마우스 클릭)</p>
                                <h3>제8조 (계약의 성립)</h3>
                                <p>1."웹사이트"은 제7조와 같은 구매신청에 대하여 다음 각 호에 해당하지 않는 한 승낙합니다.<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;가)신청 내용에 허위, 기재누락, 오기가 있는 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;나)미성년자가 담배, 주류 등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;다)기타 구매신청에 승낙하는 것이 "웹사이트" 기술상 현저히 지장이 있다고 판단하는 경우<br />
                                    2."웹사이트"의 승낙은 제10조 제1항의 수신확인 통지 형태로 이용자에게 도달한 시점에 이루어지며, 이 때 계약이 성립한 것으로 봅니다.</p>
                                <h3>제9조 (계약의 해지)</h3>
                                <p>웹사이트"에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각 호의 하나로 할 수 있습니다.<br />
                                    1. 계좌이체<br />
                                    2. 신용카드결제<br />
                                    3. 온라인무통장입금<br />
                                    4. 기타 "웹사이트"가 인정하는 결제수단 등</p>

                                <h3>제10조(수신확인통지·구매신청 변경 및 취소)</h3>
                                <p>1."웹사이트"은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.<br />
                                    2.수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있습니다.<br />
                                    3."웹사이트"은 배송전 이용자의 구매신청 변경 및 취소 요청이 있는 때에는 지체 없이 그 요청에 따라 처리합니다.</p>
                                <h3>제11조(배송, 적립금)</h3>
                                <p>1."웹사이트"은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 "웹사이트"의 고의에 의한 중대한 과실로 약정 배송기간을 초과한
                                    경우에는 그로 인한 이용자의 손해를 배상합니다.<br />
                                    2."웹사이트"은 이용자가 구매완료한 재화에 대하여 소정의 적립금을 지급합니다. 단 이 기간은 물품 배송일로 부터 약 1개월로 한정하며, 이용자가 구매완료후 직접
                                    내려받습니다. (구입완료후 반품 및 교환은 기본적으로 불가합니다.)</p><br />

                                <h2>제4장 청약의 철회 및 최저가보상 </h2><br />
                                <h3>제12조(환급, 반품 및 교환)</h3>
                                <p>
                                    1."웹사이트"은 이용자가 구매 신청한 재화 또는 용역이 품절 등의 사유로 재화의 인도 또는 용역의 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고, 사전에 재화 또는
                                    용역의 대금을 받은 경우에는 대금을 받은 날부터 3일 이내에, 그렇지 않은 경우에는 그 사유 발생일로부터 3일 이내에 계약해제 및 환급절차를 취합니다.<br />
                                    2.다음 각 호의 경우에는 "웹사이트"은 배송된 재화일지라도 재화를 반품 받은 다음 영업일 이내에 이용자의 요구에 따라 즉시 환급, 반품 및 교환 조치를 합니다. 다만 그 요구기한은 배송된
                                    날로부터 7일 이내로 합니다.<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;가) 배송된 재화가 주문내용과 상이하거나 "웹사이트"가 제공한 정보와 상이할 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;나) 배송된 재화가 파손, 손상되었거나 오염되었을 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;다) 재화가 광고에 표시된 배송기간보다 늦게 배송된 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;라) 방문판매등에관한법률 제18조에 의하여 광고에 표시하여야 할 사항을 표시하지 아니한 상태에서 이용자의 청약이 이루어진 경우<br />
                                    3.다음 각 호의 경우에는 배송된 재화의 교환 및 반품이 제한 될 수 있습니다.<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;가) 반품된 재화의 상품가치가 현저히 감소했을 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;나) 이용자가 구입완료를 선택하여 적립금을 내려 받은 이후 발생되는 반품의 경우
                                </p><br />
                                <h2>제5장 회원정보의 보호 및 보안관리</h2><br />
                                <h3>제13조(개인정보보호)</h3>

                                <p>1."웹사이트"은 이용자의 정보수집시 구매계약 이행에 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외 사항은 선택사항으로 합니다.<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;가) 성명 (한글, 영문)<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;나) 주민등록번호(회원, 비회원 공통)<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;다) 주소<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;라) 전화번호<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;마) 희망ID(회원의 경우)<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;바) 비밀번호(회원의 경우)<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;사) 주문 비밀번호<br />
                                    2."웹사이트"가 이용자의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.<br />
                                    3.제공된 개인정보는 당해 이용자의 동의없이 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 "웹사이트"가 집니다. 다만, 다음의 경우에는 예외로 합니다.<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;가) 배송업무상 배송업체에게 배송에 필요한 최소한의 이용자의 정보(성명, 주소, 전화번호) 를 알려주는 경우<br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;나) 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우<br />
                                    4."웹사이트"가 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한
                                    정보제공 관련사항(제공받는자, 제공목적 및 제공할 정보의 내용)등 정보 통신망 이용촉진 등에 관한 법률 제16조제3항이 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지
                                    이 동의를 철회할 수 있습니다.<br />
                                    5.이용자는 언제든지 "웹사이트"가 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 "웹사이트"은 이에 대해 지체없이 필요한 조치를 취할 의무를 집니다. 이용자가
                                    오류의 정정을 요구한 경우에는 "웹사이트"은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.<br />
                                    6."웹사이트"은 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에
                                    대하여 모든 책임을 집니다.<br />
                                    7."웹사이트" 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체없이 파기합니다.</p>

                                <br />
                                <h2>제6장 회사의 의무와 회원의 의무</h2><br />
                                <h3>제14조("웹사이트"의 의무)</h3>
                                <p>1."웹사이트" 은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화용역을 제공하는 데 최선을 다하여야 합니다.<br />
                                    2."웹사이트"은 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.<br />
                                    3."웹사이트"가 상품이나 용역에 대하여 「표시광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.<br />
                                    4."웹사이트"은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</p>

                                <h3>제15조( 회원의 ID 및 비밀번호에 대한 의무)</h3>
                                <p>1.제13조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.<br />
                                    2.회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.<br />
                                    3.회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 "웹사이트"에 통보하고 "웹사이트"의 안내가 있는 경우에는 그에 따라야 합니다.</p>
                                <h3>제16조(이용자의 의무)</h3>
                                <p>이용자는 다음 행위를 하여서는 안됩니다.<br />
                                    1. 신청 또는 변경시 허위내용의 등록<br />
                                    2. "웹사이트"에 게시된 정보의 변경<br />
                                    3. "웹사이트"가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시<br />
                                    4. "웹사이트" 기타 제3자의 저작권 등 지적재산권에 대한 침해<br />
                                    5. "웹사이트" 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br />
                                    6. 외설 또는 폭력적인 메시지화상음성 기타 공서양속에 반하는 정보를 웹사이트에 공개 또는 게시하는 행위</p><br />


                                <h2>제7장 저작권</h2><br />
                                <h3>제17조(저작권의 귀속 및 이용제한)</h3>
                                <p>1."웹사이트"가 작성한 저작물에 대한 저작권 기타 지적재산권은 "웹사이트"에 귀속합니다.<br />
                                    2.이용자는 "웹사이트"을 이용함으로써 얻은 정보를 "웹사이트"의 사전 승낙없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.</p>


                                <h3>제18조(분쟁해결)</h3>
                                <p>1."웹사이트"은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구(고객만족센터)를 설치하여 운영합니다.<br />
                                    2."웹사이트"은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.<br />
                                    3. "웹사이트"과 이용자간에 발생한 분쟁은 전자거래기본법 제28조 및 동 시행령 제15조에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.</p>
                                <h3>제19조(재판권 및 준거법)</h3>
                                <p>1."웹사이트"과 이용자간에 발생한 전자거래 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.<br />
                                    2."웹사이트"과 이용자간에 제기된 전자거래 소송에는 한국법을 적용합니다.</p>

                                <br />
                                <p>부 칙 본 약관은 2007년 12월 11일부터 시행 합니다.</p>

                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default TermsCondition; 